import axiosClient from "@/services/api/index";
import {
  ColorSchemeInterface,
  CreateColorSchemeInterface,
  ExternalColorSchemeInterface,
  QueryColorSchemeInterface,
  QueryExternalColorSchemeInterface,
  QueryInternalColorSchemeInterface,
  UpdateColorSchemeInterface,
} from "@/types/ColorSchemeInterface";

export default {
  async createColorScheme(
    params: CreateColorSchemeInterface
  ): Promise<ExternalColorSchemeInterface> {
    return axiosClient
      .post("color-scheme", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async uploadImageColorScheme(
    builderId: string,
    image: FormData
  ): Promise<unknown> {
    return axiosClient
      .post(`color-scheme/images/${builderId}`, image)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getColorSchemeByQuery(
    params: QueryColorSchemeInterface
  ): Promise<ColorSchemeInterface[]> {
    return axiosClient
      .get("color-scheme", { params })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async deleteColorScheme(id: string): Promise<void> {
    return axiosClient
      .delete(`color-scheme/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async updateColorScheme(
    dto: UpdateColorSchemeInterface,
    id: string
  ): Promise<void> {
    return axiosClient
      .patch(`color-scheme/${id}`, dto)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },
};
